import { useQuery } from 'react-query';
import { camelize } from '../camelize';

const getAuthenticationStatus = () => fetch('api/account/getauthenticationstatus').then(response => response.json()).then(camelize);

export const useAuthenticationStatus = () => useQuery('authenticationStatus', getAuthenticationStatus);
